/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let Column: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M227.555328 113.777664h455.11168c31.418368 0 56.88832 25.469952 56.88832 56.889344v682.665984c0 31.419392-25.469952 56.889344-56.88832 56.889344H227.555328c-31.418368 0-56.88832-25.469952-56.88832-56.889344V170.667008c0-31.419392 25.469952-56.889344 56.88832-56.889344z m597.334016 0c15.70816 0 28.443648 12.735488 28.443648 28.444672V881.77664c0 15.709184-12.734464 28.444672-28.443648 28.444672-15.710208 0-28.444672-12.735488-28.444672-28.444672V142.22336c0-15.709184 12.734464-28.444672 28.444672-28.444672z m-512 170.667008c-15.710208 0-28.444672 12.734464-28.444672 28.444672 0 15.70816 12.734464 28.443648 28.444672 28.443648h284.443648c15.710208 0 28.444672-12.734464 28.444672-28.443648 0-15.710208-12.734464-28.444672-28.444672-28.444672H312.889344z m0 113.77664c-15.710208 0-28.444672 12.735488-28.444672 28.445696 0 15.70816 12.734464 28.443648 28.444672 28.443648h284.443648c15.710208 0 28.444672-12.734464 28.444672-28.443648 0-15.710208-12.734464-28.444672-28.444672-28.444672H312.889344z m0 113.778688c-15.710208 0-28.444672 12.735488-28.444672 28.444672s12.734464 28.444672 28.444672 28.444672h170.665984c15.709184 0 28.444672-12.735488 28.444672-28.444672S499.264512 512 483.555328 512H312.889344z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

Column.defaultProps = {
  size: 18,
};

Column = React.memo ? React.memo(Column) : Column;

export default Column;
